var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddSquare = function SvgAddSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7774 3H8.23161C4.95397 3 3 4.953 3 8.229V15.762C3 19.047 4.95397 21 8.23161 21H15.7684C19.046 21 21 19.047 21 15.771V8.229C21.009 4.953 19.055 3 15.7774 3ZM15.6063 12.675H12.6798V15.6C12.6798 15.969 12.3737 16.275 12.0045 16.275C11.6353 16.275 11.3291 15.969 11.3291 15.6V12.675H8.40269C8.03351 12.675 7.72736 12.369 7.72736 12C7.72736 11.631 8.03351 11.325 8.40269 11.325H11.3291V8.4C11.3291 8.031 11.6353 7.725 12.0045 7.725C12.3737 7.725 12.6798 8.031 12.6798 8.4V11.325H15.6063C15.9755 11.325 16.2816 11.631 16.2816 12C16.2816 12.369 15.9755 12.675 15.6063 12.675Z",
    fill: "#037DD6"
  })));
};
export default SvgAddSquare;